export const OrderLabelViewConstants = {
    HYPEN: ' - ',
    MAX_COURIER_LABELS: 5,
    MAX_MATCHED_LABELS: 5,
    MAX_WHITE_LABELS: 5,
    MAX_WIDTH_TABLE: 100,
  };
